import { render } from "./Notes.vue?vue&type=template&id=84af881a&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"

import "./Notes.vue?vue&type=style&index=0&id=84af881a&scoped=true&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84af881a"]])

export default __exports__